<template>
  <div class="wrap">
    <div class="part1">
      <Head />
      <p class="p1">
        <span>{{$t('m_hwtool.part1.tit1')}}</span>
        <span>HWTool</span>
      </p>
      <p class="p2">{{$t('m_hwtool.part1.tit2')}}</p>
      <div class="down">
        <a class="ios" href="https://testflight.apple.com/join/P3hprKuv">
          <i :class="lang == 'en'? 'iconfont iconios-2 i1en' :'iconfont iconios-2 i1cn'"></i>
          <span>iOS{{$t('m_hwtool.part1.down')}}</span>
        </a>
        <a class="and" href="https://toolserver.hwelltech.com/download/hwtool-last.apk">
          <i :class="lang == 'en'? 'iconfont iconandroid i2en' :'iconfont iconandroid i2cn'"></i>
          <span>Android{{$t('m_hwtool.part1.down')}}</span>
        </a>
      </div>
    </div>

    <div class="part2">
      <div class="fenge"></div>
      <p class="tit1">{{$t('m_hwtool.part2.tit')}}</p>
  
      <div class="item">
        <div class="left">
          <div class="image">
            <img src="../../assets/images/mobile/hwtool/part2-1.png" alt />
          </div>
        </div>
        <div class="right">
          <p class="p1">{{$t('m_hwtool.part2.title1')}}</p>
          <p class="p2">{{$t('m_hwtool.part2.text1')}}</p>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="image">
            <img src="../../assets/images/mobile/hwtool/part2-2.png" alt />
          </div>
        </div>
        <div class="right">
          <p class="p1">{{$t('m_hwtool.part2.title2')}}</p>
          <p class="p2">{{$t('m_hwtool.part2.text2')}}</p>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="image">
            <img src="../../assets/images/mobile/hwtool/part2-3.png" alt />
          </div>
        </div>
        <div class="right">
          <p class="p1">{{$t('m_hwtool.part2.title3')}}</p>
          <p class="p2">{{$t('m_hwtool.part2.text3')}}</p>
        </div>
      </div>
     
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import Vue from "vue";

export default {
  data() {
    return {
      window: window
    };
  },
  components: {
    Head,
    Foot
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      var lang;
      if (this.$i18n.locale == "en") {
      
        this.lang = "en";
      } else {
      
        this.lang = "cn";
      }
    },
  }
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(790);
  width: vw(750);
  position: relative;
  background-image: url('../../assets/images/mobile/hwtool/bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  padding-top: vw(98);

  .p1 {
    font-size: vw(48);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-top: vw(35);
    span:nth-child(1){
        display:inline-block;
        margin-right:vw(12);
    }
  }

  .p2 {
    font-size: vw(29);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-top: vw(20);
    padding: 0 vw(25);
  }

  .down {
     margin: vw(105) vw(120) 0;

    .ios {
      width: vw(510);
      height: vw(100);
      border: vw(1.5) solid rgba(255, 255, 255, 1);
      border-radius: vw(50);
      display:inline-block;
      position:relative;
      // opacity:0.5;
      i{
        font-size:vw(75);
        color:#fff;
        line-height:vw(95);
        margin:0  vw(35)  0  vw(136);
      }
      .i1en{
          margin:0  vw(35)  0  vw(150);
      }
      span{
       font-size:vw(36);
       position:absolute;
        color:#fff;
       top:vw(25);
      }
    }
    .and{
      width: vw(510);
      height: vw(100);
      border: vw(1.5) solid rgba(255, 255, 255, 1);
      border-radius: vw(50);
      display:inline-block;
      position:relative;
      margin-top:vw(63);
      i{
        font-size:vw(75);
        color:#fff;
        line-height:vw(95);
        margin:0  vw(35)  0  vw(93);
      }
      .i2en{
         margin:0  vw(35)  0  vw(123);
      }
      span{
       font-size:vw(36);
       position:absolute;
        color:#fff;
       top:vw(25);
      }
    }
  }
}

.part2 {
  overflow: hidden;
  width: vw(750);
  background-color: #fff;

  .fenge {
    fenge();
  }

  .tit1 {
    tit1();
  }

  .tit2 {
    tit2();
  }

  .item {
    width: vw(653);
    height: vw(206);
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    margin-top: vw(24);
    padding: 0 vw(25);
    display: flex;

    .left {
      width: vw(135);
      height: vw(206);
      overflow: hidden;

      .image {
        width: vw(110);
        height: vw(110);
        margin-top: vw(48);

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .right {
      flex: 1;
      padding-left: vw(24);

      .p1 {
        font-size: vw(31);
        font-weight: 400;
        color: rgba(49, 65, 133, 1);
        line-height: 1.2;
        margin-top: vw(38);
      }

      .p2 {
        font-size: vw(25);
        font-weight: 400;
        color: rgba(131, 146, 176, 1);
        line-height: 1.8;
        margin-top: vw(16);
      }
    }

    &:last-child {
      margin-bottom: vw(61);
    }
  }
}
</style>
